export default function () {

}



// WEBPACK FOOTER //
// ./Client/app/report/index.js